import 'vuetify/styles'
import {createVuetify} from 'vuetify'

import {aliases, mdi} from 'vuetify/iconsets/mdi'
import '@mdi/font/css/materialdesignicons.css'

import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

export default createVuetify({
    components,
    directives,
    icons: {
        defaultSet: 'mdi',
        aliases,
        sets: {mdi},
    },
    defaults: {
        VRadioGroup: {hideDetails: 'auto', density: 'comfortable'},
        VTextField: {hideDetails: 'auto', density: 'comfortable'},
        VTextarea: {hideDetails: 'auto', density: 'comfortable'},
        VSelect: {hideDetails: 'auto', density: 'comfortable'},
        VBtn: { color: 'primary', variant: 'flat', rounded: 'md', class: 'text-none' }
    },
    theme: {
        defaultTheme: 'light',
        themes: {
            light: {
                colors: {
                    // background: '#f0ebf8',
                    // surface: '#FFFFFF',
                    // primary: '#673AB7',
                    'on-primary': '#FFFFFF'
                }
            }
        }
    }
})
